export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8677.6c5092d8.jpg";